import styled from "styled-components";

const Copyright = () => {
  return (
    <div>
      <StyledDiv>
        Poštovani autori i nosioci autorskih prava,
        <br></br>
        <br></br>Želimo da Vam se izvinimo što nismo stigli da se svakom od vas
        javimo pre postavljanja prezentacije na internet.
        <br></br>Zbog kompleksnosti projekta ali i broja tekstova nije bilo
        moguće da dođemo do svakog od Vas.
        <br></br>Želeli bismo da naglasimo da je ovaj projekat izrazito
        edukativnog karaktera i ni na koji način nije komercijalan.
        <br></br>Ideja nam je bila da omogućimo što većem broju zainteresovanih
        da pročitaju tekstove do kojih, na žalost, nije lako doći.
        <br></br>Iz tog razloga smo odlučili da postavimo prezentaciju na
        internet i da Vas naknadno kontaktiramo.
        <br></br>Nadamo se da ćete podržati našu želju da putem prezentacije
        fonda Odeljenja za umetničku dokumentaciju informacije o našim
        umetnicima učinimo dostupnim.
        <br></br>Po dogovoru sa vama, na ovom mestu će se naći Uslovi korišćenja
        materijala na sajtu.
        <br></br>Naš predlog je Creative Commens licenca "autorstvo -
        nekomercijalno - deliti pod istim uslovima".
        <br></br>Ova licenca zabranjuje komercijalnu upotrebu i preradu dela.
        <br></br> O detaljima ove licence se možete obavestiti na sajtu
        http://creativecommons.org.rs.
        <br></br> <br></br>Za sva pitanja, sugestije i primedbe možete se
        obratiti na e-mail: biblioteka@msub.org.rs.
        <br></br>
        <br></br>Hvala na razumevanju.
      </StyledDiv>
    </div>
  );
};

const StyledDiv = styled.div`
  margin-top: 2rem;

  @media (max-width: 768px) {
    margin-top: 4rem;
  }
`;

export default Copyright;
